export default {
  SEARCH_BP: "SEARCH_BP",
  SEARCH_BP_SUCCEEDED: "SEARCH_BP_SUCCEEDED",
  RESET_SEARCH_BP_SUCCEEDED_FLAG: "RESET_SEARCH_BP_SUCCEEDED_FLAG",
  CLEAR_BP_LIST: "CLEAR_BP_LIST"
};
